<template>
  <div class="about-us" v-html="aboutUsText"></div>
</template>

<script>
import { getAboutUs } from "@/utils/api/user";
export default {
  data() {
    return {
      aboutUsText: ``
    };
  },
  mounted() {
    getAboutUs().then((res) => {
      if (res.success) {
        this.aboutUsText = res.data.contents;
      }
    });
  }
};
</script>

<style lang="scss">
.about-us {
  padding: 0 20px;
  padding-top: 28px;
  img {
    max-width: 335px;
  }
  p {
    &:first-child {
      text-indent: 0px;
    }
    line-height: 32px;
    text-indent: 28px;
    font-size: 14px;
    color: #666;
    text-align: left;
  }
}
</style>
